var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStackedAreaIcon = function SvgStackedAreaIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 11,
    fill: "none",
    viewBox: "0 0 15 11"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#StackedAreaIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#52AEA4",
    d: "M0 7.96V11h15V7.96s-2.01-1.03-2.74-.94c-.94.11-2.14 1.9-3.08 1.99-1.03.1-1.8-2.01-2.84-1.99-.46 0-1.57.99-1.98 1.18C3.38 8.64 0 7.97 0 7.97z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C6FF7",
    d: "M12.67 0c-1.21.09-2.2 2.84-3.36 3.15-.72.19-1.97-1.2-2.72-1.13-.83.08-1.51 1.88-2.23 2.25-.94.49-4.36 0-4.36 0v2.47s3.39.68 4.36.23c.41-.19 1.52-1.17 1.98-1.18 1.04-.02 1.81 2.09 2.84 1.99.94-.09 2.14-1.88 3.08-1.99.73-.08 2.74.94 2.74.94V1.58S13.4-.05 12.67 0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "StackedAreaIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h15v11H0z"
  })))));
};
export default SvgStackedAreaIcon;